import { API_URL } from "../redux/Consts";
import moment from "moment-timezone";
export enum StorageType {
  SOCIAL_TOKEN = "SocialToken",
  ACCESS_TOKEN = "AccessToken",
  REGISTER_EMAIL = "RegisterEmail",
  SELECTED_NODE_ID = "SelectedNodeId",
  SELECTED_END_NODE_ID = "SelectedENDNodeId",
  MONITOR_NODE_ID = "MonitorNodeId",
  BASE_END_NODE_ID = "BASENodeId",
  VIEW_AND_PRESENTATION = "VIEW_AND_PRESENTATION",
  IS_LOGGED_OUT = "isLoggedOut",
  IS_IOS_NATIVE_LOGOUT = "isIosNativeLogOut",
  VERSION = "version",
  LAST_VISITED_PAGE = "VitalerterlastPage",
  CURRENT_OPEN_RESIDENT = "currentOpenResident",
  CURRENT_PLAN_CONFIG = "currentPlanConfig",
  CLOSED_BANNER = "closedBaner",
  LAST_UPDATE_SHOWN = "lastUpdateShownOccupancy",
}
const local = API_URL();
type tokenInfos = {
  token: string;
  date: Date;
  application: string;
  expiresIn: number;
  refreshToken: string;
};
type loggedOut = {
  value: boolean;
  application: string;
};

const isNativeApp = () => {
  return true;
};
class StorageHelper {
  private static _instance: StorageHelper;
  static get instance(): StorageHelper {
    this._instance || (this._instance = new StorageHelper());
    return this._instance;
  }
  SaveLoggedOut = (value: boolean): void => {
    const logoutData: loggedOut = { value, application: local + "vitalerter" };
    localStorage.setItem(StorageType.IS_LOGGED_OUT, JSON.stringify(logoutData));
  };

  GetLoggedOut = (): boolean => {
    const logoutData: loggedOut = JSON.parse(
      localStorage.getItem(StorageType.IS_LOGGED_OUT)
    );
    return logoutData !== null && logoutData !== undefined
      ? logoutData?.value
      : undefined;
  };

  SaveIsIosNativeLoginOut = (value: boolean): void => {
    console.log("save isIos" + value);
    const logoutData: loggedOut = { value, application: local + "vitalerter" };
    localStorage.setItem(
      StorageType.IS_IOS_NATIVE_LOGOUT,
      JSON.stringify(logoutData)
    );
  };

  GetIsIosNativeLoginOut = (): boolean => {
    const logoutData: loggedOut = JSON.parse(
      localStorage.getItem(StorageType.IS_IOS_NATIVE_LOGOUT)
    );
    console.log(logoutData);
    return logoutData !== null && logoutData !== undefined
      ? logoutData?.value
      : undefined;
  };

  SaveSocialToken = (token: string): void => {
    localStorage.setItem(StorageType.SOCIAL_TOKEN, JSON.stringify(token));
  };
  GetSocialToken = (): string => {
    const result = localStorage.getItem(StorageType.SOCIAL_TOKEN);
    return JSON.parse(result);
  };
  ClearSocialToken = (): void => {
    localStorage.removeItem(StorageType.SOCIAL_TOKEN);
  };

  SaveAccessToken = (
    token: string,
    expiresIn?: number,
    refreshToken?: string
  ): void => {
    const tokenWithData: tokenInfos = {
      token,
      date: new Date(),
      application: "vitalerter" + local,
      expiresIn: expiresIn,
      refreshToken: refreshToken,
    };
    console.log("save accessToken");

    localStorage.setItem(
      StorageType.ACCESS_TOKEN,
      JSON.stringify(tokenWithData)
    );
  };

  GetExpireDate = (): Date => {
    const result: tokenInfos = JSON.parse(
      localStorage.getItem(StorageType.ACCESS_TOKEN)
    );

    if (!result) return undefined;
    if (
      result?.application === undefined ||
      result.application !== "vitalerter" + local
    )
      return undefined;
    // console.log(result);
    return moment(result.date).add(result.expiresIn, "second").toDate();
  };

  GetRefreshToken = (): string => {
    const result: tokenInfos = JSON.parse(
      localStorage.getItem(StorageType.ACCESS_TOKEN)
    );

    if (!result) return undefined;
    if (
      result?.application === undefined ||
      result.application !== "vitalerter" + local
    )
      return undefined;
    // console.log(result);
    return result.refreshToken;
  };

  GetAccessToken = (): string => {
    const result: tokenInfos = JSON.parse(
      localStorage.getItem(StorageType.ACCESS_TOKEN)
    );

    if (!result) return undefined;
    if (
      result?.application === undefined ||
      result.application !== "vitalerter" + local
    )
      return undefined;
    // console.log(result);
    return result.token;
  };

  UpdateAccessTokenRegion = (newLocal: string): void => {
    const result: tokenInfos = JSON.parse(
      localStorage.getItem(StorageType.ACCESS_TOKEN)
    );
    const tokenWithData: tokenInfos = {
      ...result,
      date: new Date(),
      application: "vitalerter" + newLocal,
    };
    localStorage.setItem(
      StorageType.ACCESS_TOKEN,
      JSON.stringify(tokenWithData)
    );
  };
  SaveVersion = (version: string): void => {
    localStorage.setItem(StorageType.VERSION, version);
  };
  GetVersion = (): string => {
    return localStorage.getItem(StorageType.VERSION);
  };
  SavePage = (page: string, userId: string): void => {
    const item = { page, userId };
    const isNative = false; //isNativeApp();
    if (isNative)
      localStorage.setItem(StorageType.LAST_VISITED_PAGE, JSON.stringify(item));
    else
      sessionStorage.setItem(
        StorageType.LAST_VISITED_PAGE,
        JSON.stringify(item)
      );
  };
  GetPage = (userId: string): string => {
    const isNative = false; // isNativeApp();
    const item = isNative
      ? JSON.parse(localStorage.getItem(StorageType.LAST_VISITED_PAGE))
      : JSON.parse(sessionStorage.getItem(StorageType.LAST_VISITED_PAGE));
    return item?.page; //userId === item?.userId ? item?.page : undefined;
  };
  ClearPage = (): void => {
    const isNative = false; // isNativeApp();
    isNative
      ? localStorage.removeItem(StorageType.LAST_VISITED_PAGE)
      : sessionStorage.removeItem(StorageType.LAST_VISITED_PAGE);
  };
  SaveResident = (page: string): void => {
    const item = { page };
    sessionStorage.setItem(
      StorageType.CURRENT_OPEN_RESIDENT,
      JSON.stringify(item)
    );
  };
  GetResident = (): string => {
    const item = JSON.parse(
      sessionStorage.getItem(StorageType.CURRENT_OPEN_RESIDENT)
    );
    return item?.page; //userId === item?.userId ? item?.page : undefined;
  };
  ClearResident = (): void => {
    sessionStorage.removeItem(StorageType.CURRENT_OPEN_RESIDENT);
  };

  ClearConfigType = (): void => {
    sessionStorage.removeItem(StorageType.CURRENT_PLAN_CONFIG);
  };

  ClearAccessToken = (): void => {
    console.log("clean accessToken");

    localStorage.removeItem(StorageType.ACCESS_TOKEN);
    const deletedKeys: string[] = [];
    Object.keys(localStorage).map((key) => {
      if (key.indexOf("auth0spajs") !== -1) deletedKeys.push(key);
      return null;
    });
    deletedKeys.forEach((key) => this.remove(key));
    // localStorage.removeItem('@@')
  };

  SaveRegisterEmail = (email: string): void => {
    localStorage.setItem(StorageType.REGISTER_EMAIL, JSON.stringify(email));
  };
  GetRegisterEmail = (): string => {
    const result = localStorage.getItem(StorageType.REGISTER_EMAIL);
    return JSON.parse(result);
  };
  ClearRegisterEmail = (): void => {
    localStorage.removeItem(StorageType.REGISTER_EMAIL);
  };

  SaveItem = (type: StorageType, value: any, keyParam?: string): void => {
    keyParam
      ? this.set(type + keyParam, JSON.stringify(value))
      : this.set(type, JSON.stringify(value));
  };
  GetItem = (type: StorageType, keyParam?: string): string => {
    const result = keyParam ? this.get(type + keyParam) : this.get(type);
    return result ? (result as any).toString() : undefined;
  };
  ClearItem = (type: StorageType, keyParam?: string): void => {
    keyParam ? this.remove(type + keyParam) : this.remove(type);
    // localStorage.removeItem(type);
  };
  set(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
    sessionStorage.setItem(key, JSON.stringify(value));
  }
  get(key: string) {
    if (localStorage.getItem(key) && localStorage.getItem(key) !== "undefined")
      return localStorage.getItem(key)
        ? JSON.parse(localStorage.getItem(key))
        : sessionStorage.getItem(key)
        ? JSON.parse(sessionStorage.getItem(key))
        : undefined;
    return undefined;
  }
  remove(key: string) {
    localStorage.removeItem(key);
  }

  ///session storage
  SaveSessionItem = (
    type: StorageType,
    value: any,
    keyParam?: string
  ): void => {
    const isNative = isNativeApp();
    if (isNative)
      keyParam
        ? this.set(type + keyParam, JSON.stringify(value))
        : this.set(type, JSON.stringify(value));
    else
      keyParam
        ? this.setSession(type + keyParam, JSON.stringify(value))
        : this.setSession(type, JSON.stringify(value));
  };
  GetSessionItem = (type: StorageType, keyParam?: string): string => {
    const isNative = isNativeApp();
    const result = isNative
      ? keyParam
        ? this.get(type + keyParam)
        : this.get(type)
      : keyParam
      ? this.getSession(type + keyParam)
      : this.getSession(type);
    return result ? (result as any).toString() : undefined;
  };
  ClearSessionItem = (type: StorageType): void => {
    const isNative = isNativeApp();
    if (isNative) this.remove(type);
    else this.removeSession(type);
    // localStorage.removeItem(type);
  };
  setSession(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
  getSession(key: string): any {
    if (
      sessionStorage.getItem(key) &&
      sessionStorage.getItem(key) !== "undefined"
    )
      return sessionStorage.getItem(key)
        ? JSON.parse(sessionStorage.getItem(key))
        : undefined;
    return undefined;
  }
  removeSession(key: string) {
    sessionStorage.removeItem(key);
  }
}
export { StorageHelper };
